// app/dashboard/report.tsx
import React, { useEffect, useMemo, useState } from 'react';
import { Appbar, useTheme, Surface, SegmentedButtons } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { WeeklyDrivingReport } from '@components/screens/driver/WeeklyDrivingReport';
import { DailyDrivingReport } from '@components/DailyDrivingReport';
import { useLocalSearchParams, useRouter } from 'expo-router';

export default function ReportPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const router = useRouter();
  const { view } = useLocalSearchParams<{ view?: string }>();

  const initialView = useMemo<'daily' | 'weekly'>(() => (view === 'weekly' ? 'weekly' : 'daily'), [view]);
  const [selectedView, setSelectedView] = useState<'daily' | 'weekly'>(initialView);

  useEffect(() => {
    setSelectedView(initialView);
  }, [initialView]);

  const onChangeView = (next: string) => {
    const nextView = next === 'daily' ? 'daily' : 'weekly';
    setSelectedView(nextView);
    router.replace({ pathname: '/dashboard/report', params: { view: nextView } });
  };

  return (
    <Surface style={{ flex: 1 }}>
      <Appbar.Header style={{ backgroundColor: theme.colors.surfaceVariant }}>
        <Appbar.BackAction onPress={() => router.back()} />
        <Appbar.Content title={selectedView === 'daily' ? t('dailyDrivingReport') : t('weeklyDrivingReport')} />
      </Appbar.Header>
      <Surface style={{ paddingHorizontal: 16, paddingTop: 12, backgroundColor: theme.colors.surface }}>
        <SegmentedButtons
          value={selectedView}
          onValueChange={onChangeView}
          buttons={[
            { value: 'daily', label: t('dailyDrivingReport') },
            { value: 'weekly', label: t('weeklyDrivingReport') },
          ]}
        />
      </Surface>
      {selectedView === 'daily' ? <DailyDrivingReport /> : <WeeklyDrivingReport />}
    </Surface>
  );
}